import { useTranslation } from 'react-i18next'
import { MarketingPage } from '@/components/marketing/marketing-page'
import { ProseSection, ProseParagraphs } from '@/components/marketing/prose-section'
import { MarketingCta } from '@/components/marketing/marketing-cta'
import { RelatedLinks } from '@/components/marketing/related-links'
import { FaqSection } from '@/components/marketing/faq-section'
import { buildRelatedLinks } from '@/components/marketing/links'
import { arrayKey } from '@/components/marketing/i18n-array'
import { JsonLd } from '@/components/seo/json-ld'
import {
  breadcrumbSchema,
  articleSchema,
  faqSchema,
} from '@/components/marketing/marketing-schema'

const KEY = 'whatIsKnowledgeGraph'
const PATH = '/what-is-a-knowledge-graph'

export function WhatIsKnowledgeGraphPage() {
  const { t, i18n } = useTranslation()
  const section = (name: string) => arrayKey(t, `marketing.${KEY}.${name}.body`)
  const faq = faqSchema(t, KEY)

  return (
    <MarketingPage
      seoTitle={t(`marketing.${KEY}.seo.title`)}
      seoDescription={t(`marketing.${KEY}.seo.description`)}
      path={PATH}
      eyebrow={t(`marketing.${KEY}.eyebrow`)}
      heading={t(`marketing.${KEY}.h1`)}
      lead={t(`marketing.${KEY}.lead`)}
    >
      <JsonLd data={breadcrumbSchema(KEY)} />
      <JsonLd
        data={articleSchema({
          headline: t(`marketing.${KEY}.h1`),
          description: t(`marketing.${KEY}.seo.description`),
          path: PATH,
          language: i18n.language,
        })}
      />
      {faq && <JsonLd data={faq} />}

      <ProseSection title={t(`marketing.${KEY}.definition.title`)}>
        <ProseParagraphs paragraphs={section('definition')} />
      </ProseSection>
      <ProseSection title={t(`marketing.${KEY}.whyCitations.title`)}>
        <ProseParagraphs paragraphs={section('whyCitations')} />
      </ProseSection>
      <ProseSection title={t(`marketing.${KEY}.vsChat.title`)}>
        <ProseParagraphs paragraphs={section('vsChat')} />
      </ProseSection>
      <ProseSection title={t(`marketing.${KEY}.howMindweb.title`)}>
        <ProseParagraphs paragraphs={section('howMindweb')} />
      </ProseSection>

      <FaqSection contentKey={KEY} />

      <MarketingCta
        title={t(`marketing.${KEY}.cta.title`)}
        body={t(`marketing.${KEY}.cta.body`)}
        buttonLabel={t(`marketing.${KEY}.cta.button`)}
        to="/"
      />
      <RelatedLinks
        heading={t('marketing.common.relatedHeading')}
        links={buildRelatedLinks(t, KEY, [
          'comparePerplexity',
          'compareNotebooklm',
          'useCasesResearchers',
        ])}
      />
    </MarketingPage>
  )
}
